import React from 'react';
import map from 'lodash/map';
import get from 'lodash/get';

import OfferBanner from '~/components/OfferBanner';
import nls from './nls/Landing';
import { createTranslator } from '~/lib/nls-helper';
import PropTypes from 'prop-types';
import { FormLayout, Heading, Row, withTrackPage } from '@piggybank/core';

import { isMobile } from '~/genericFunctions';

import styles from './landing.module.css';

const NLS = createTranslator(nls);

const OfferBanners = (offers, globalData) => (
  map(offers, (offer, index) => {
    return (
      <Row key={`offerBannerRow${index}`}>
        <div className={styles.OfferBannerWrap}>
          <OfferBanner
            background={{
              color: get(offer, 'banner.background.color') || 'jade',
              image: get(offer, 'banner.background.image'),
            }}
            key={`offerIndex${index}`}
            textMap={{
              heading: get(offer, 'banner.textMap.title'),
              paragraph: get(offer, 'banner.textMap.text'),

            }}
            url={`${get(offer, 'banner.button.url')}${globalData.authToken ? `&token=${globalData.authToken}&tokenType=${globalData.authTokenType}` : ''}${isMobile(globalData.ismobile) ? '&ismobile=yes' : ''}`}
          />
        </div>
      </Row>
    );
  })
);
const DefaultOfferBanner = () =>
  (
    <Row key={'DefaultOffer'}>
      <div className={styles.OfferBannerWrap}>
        <OfferBanner
          background={{
            color: 'jade',
            image: '/images/flexibleSaving-20240621.jpg',
          }}
          key="DefaultOffer"
          targetValue= "_blank"
          textMap={{
            heading: NLS`If you don't have it yet, open it at any branch.`,
            paragraph: NLS`If you already have it, select the option `,
            paragraph0: NLS`"transfer and pay"`,
            paragraph1: NLS`1.  Source account: your HSBC account`,
            paragraph2: NLS`2.  Destination account: `,
            paragraph3: NLS`HSBC Flexible Savings`,
          }}
          url="https://www.hsbc.com.mx/cuentas/ahorro-flexible-hsbc/"
        />
      </div>
    </Row>
  );

const Landing = ({ values: { data, globalData } = {} } = {}) => (
  <FormLayout>
    {
      !isMobile(globalData.ismobile) &&
        <Heading level={1}>{NLS`Products for you`}</Heading>
    }
    {OfferBanners(get(data, 'offers'), globalData)}
    {DefaultOfferBanner()}
  </FormLayout>
);

Landing.propTypes = {
  values: PropTypes.shape({
    globalData: PropTypes.shape({
      authToken: PropTypes.string,
      authTokenType: PropTypes.string,
      ismobile: PropTypes.string,
    }),
    data: PropTypes.shape({
      offers: PropTypes.arrayOf(
        PropTypes.shape({
          banner: PropTypes.shape({
            background: PropTypes.shape({
              color: PropTypes.string,
              image: PropTypes.string,
            }),
            button: PropTypes.shape({
              url: PropTypes.string,
            }),
            textMap: PropTypes.shape({
              title: PropTypes.string.isRequired,
              text: PropTypes.string.isRequired,
            }).isRequired,
          }),
        })
      ),
    }),
  }),
};

export default withTrackPage('landing', 'component')(Landing);
